import React, { Component } from 'react';
import InputSelect from '../components/inputSelect';
import {connect} from 'react-redux';
import PropTypes from "prop-types";
import { getTravels, getMonthTable } from '../../lib/ApiServices'
import moment from 'moment-timezone'

class sectionTable extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      find: {
      },
    };
  }

  async componentWillReceiveProps() {
    const seaports = await getTravels()

    const now = new Date()
    const currentMonth = now.getMonth() + 1
    const currentYear = now.getFullYear()

    // make a first query to get the first monthTable for this month & year
    const monthTable = await getMonthTable(
      { travels: seaports },
      this.props.city,
      this.props.isOrigin,
      currentMonth,
      currentYear
    )

    // set the results to the state
    this.setState({
      ...this.state,
      find: {
        month: currentMonth,
        year: currentYear
      },
      monthTableResponse: monthTable
    })
  }

  onChange = async (name, value, title, id) =>{
    await this.setState({ ...this.state, find: {...this.state.find, [name]: value }})

    // do nothing if we don't have month or year (cannot do any search)
    if (typeof this.state.find.month === 'undefined' || typeof this.state.find.year === 'undefined') {
      return;
    }

    // query to the API to get the monthTable with this component's state
    await this.setState({
      ...this.state,
      monthTableResponse:
        await getMonthTable(
          this.props.settings,
          this.props.city,
          this.props.isOrigin,
          this.state.find.month,
          this.state.find.year
        )
    })
  }

  detectLenguage = () => {
    const lang = window.location.pathname.split('/')[1]
    if(lang === 'es'){
      return true
    }else{
      return false
    }
  }

  render() {
    const city = this.props.city
    const langUrl = this.context.router.route.location.pathname.split('/')[1]
    const { languages } = this.props.settings
    const langPlace = languages[langUrl].table[city]
    const noAvailableFerriesText = languages[langUrl].noAvailableFerriesText
    const months = {
      es:
        [{ name: 'Enero', value: 1 },
        { name: 'Febrero', value: 2 },
        { name: 'Marzo', value: 3 },
        { name: 'Abril', value: 4 },
        { name: 'Mayo', value: 5 },
        { name: 'Junio', value: 6 },
        { name: 'Julio', value: 7 },
        { name: 'Agosto', value: 8 },
        { name: 'Septiembre', value: 9 },
        { name: 'Octubre', value: 10 },
        { name: 'Noviembre', value: 11 },
        { name: 'Diciembre', value: 12 }],
      
      fr:
        [{ name: 'Janvier', value: 1 },
        { name: 'Février', value: 2 },
        { name: 'Mars', value: 3 },
        { name: 'Avril', value: 4 },
        { name: 'Mai', value: 5 },
        { name: 'Juin', value: 6 },
        { name: 'Juillet', value: 7 },
        { name: 'Août', value: 8 },
        { name: 'Septembre', value: 9 },
        { name: 'Octobre', value: 10 },
        { name: 'Novembre', value: 11 },
        { name: 'Décembre', value: 12 }]
  }



    const arrayYear = [
      { name: '2018', value: 2018 },
      { name: '2019', value: 2019 },
      { name: '2020', value: 2020 },
    ]

    const errors = {}
    const values = this.state.find

    if (!this.state.monthTableResponse) {
      return <div className="container-fluid">
        <section className="section-text row">
          <div className="container">
            <div className="row">

              <div className="col-md-12">
                <h1 className="h3 heavy">{`${langPlace.title}`}</h1>
                <p className="light">{noAvailableFerriesText}</p>
              </div>
            </div>
          </div>
        </section>
      </div>

    } else {
      const monthTable = this.state.monthTableResponse

      const getFormatedMomentDiff = (now, then) => {
        const totalMinutes = moment(then).diff(moment(now), 'minutes')
        const totalHours = Math.floor(totalMinutes / 60);
        const totalDays = Math.floor(totalHours / 24);

        const days = totalDays;
        const hours = totalDays === 0 ? totalHours : totalHours % (totalDays * 24);
        const minutes = totalHours === 0 ? totalMinutes : totalMinutes % (totalHours * 60);

        const result = [];

        if (days > 0) {
          result.push(`${days}d`);
        }
        if (hours > 0) {
          result.push(`${hours}h`);
        }
        if (minutes > 0) {
          result.push(`${minutes}m`);
        }

        return result.join(' ');
      }

      return (
        <div className="container-fluid">

            <section className="section-text row">
              <div className="container">
                <div className="row">

                  <div className="col-md-12">
                    <h1 className="h3 heavy">{`${langPlace.title}`}</h1>
                    <p className="light">{langPlace.text}</p><p>&nbsp;</p>
                  </div>

                </div>
                <div className="row">

                  <div className='col-lg-12 col-md-12 col-sm-12'>
                    <div className='col-lg-6 col-md-6 col-sm-6 col-xs-6 no-padding'>
                      {this.detectLenguage() ? <InputSelect
                        name='month'
                        title='Mes'
                        value={values}
                        array={months.es}
                        errors={errors}
                        section='contact'
                        onChange={this.onChange} /> : <InputSelect
                        name='month'
                        title='Mois'
                        value={values}
                        array={months.fr}
                        errors={errors}
                        section='contact'
                        onChange={this.onChange}
                        />}
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-6 col-xs-6 no-padding'>
                      {this.detectLenguage() ? <InputSelect
                        name='year'
                        title='Año'
                        value={values}
                        array={arrayYear}
                        errors={errors}
                        section='contact'
                        onChange={this.onChange}
                        /> : <InputSelect
                        name='year'
                        title='Année'
                        value={values}
                        array={arrayYear}
                        errors={errors}
                        section='contact'
                        onChange={this.onChange}
                        />}
                    </div>
                  </div>

                </div>

                <div className="table">

                  <div className="row">
                    <div className="col-md-12 margin-top-50">
                      <div className="col-md-2 table-head">
                        <p>{langPlace.departure}</p>
                      </div>
                      <div className="col-md-2 table-head">
                        <p>{langPlace.departureArrival}</p>
                      </div>
                      <div className="col-md-2 table-head">
                        <p>{langPlace.duration}</p>
                      </div>
                      <div className="col-md-3 table-head">
                        <p>{this.props.isOrigin ? langPlace.destination : langPlace.origin}</p>
                      </div>
                      <div className="col-md-3 table-head">
                        <p>{langPlace.vessel}</p>
                      </div>
                    </div>
                  </div>

                  {monthTable.map(
                    (travel, index) => {
                      return (
                        <div key={index} className="row table-row">
                          <div className="col-md-12 ">
                            <div className="col-md-2 table-content">
                              <p>{moment(travel.departure).format('DD/MM/YYYY')}</p>
                            </div>
                            <div className="col-md-2 table-content">
                              <p>
                                {moment(travel.departure).format('HH.mm')}
                                &nbsp;/&nbsp;
                                {moment(travel.arrival).format('HH.mm')}
                              </p>
                            </div>
                            <div className="col-md-2 table-content">
                              <p>{getFormatedMomentDiff(travel.departure, travel.arrival)}</p>
                            </div>
                            <div className="col-md-3 table-content">
                              <p>{this.props.isOrigin ? travel.destination.name : travel.origin.name}</p>
                            </div>
                            <div className="col-md-3 table-content">
                              <p>{travel.ship.name}</p>
                            </div>
                          </div>
                        </div>
                      )
                    }
                  )}

                </div>

              </div>
            </section>

        </div>
      );
    }
  }
}

export default connect(
  (state) => ({settings: state.settings})
)(sectionTable)



// WEBPACK FOOTER //
// ./src/shared/routes/routeTable/sectionTable.js